import React from 'react';
import {
  exhibitionGoogleCalendarUrl,
  exhibitionGoogleMapsUrl,
  exhibitionWithDefaultRsvp,
} from '../exhibitionsDisplay';
import { ExhibitionRsvpButton } from './ExhibitionRsvpForm';

/**
 * Secondary actions on exhibition cards — directions, calendar, external event page, RSVP.
 */
export default function ExhibitionShowActions({ row, brandName, compact = false, showRsvp = true }) {
  const show = exhibitionWithDefaultRsvp(row);
  const mapsUrl = exhibitionGoogleMapsUrl(show);
  const calendarUrl = exhibitionGoogleCalendarUrl(show, { brandName });
  const externalUrl = String(show?.external_url || '').trim();
  const rsvpOpen =
    showRsvp &&
    (show?.rsvp_enabled || show?.preorder_enabled) &&
    !(show?.rsvp_full && !show?.preorder_enabled);

  if (!mapsUrl && !calendarUrl && !externalUrl && !rsvpOpen) return null;

  const className = `exhibition-show-actions${compact ? ' exhibition-show-actions--compact' : ''}`;

  return (
    <div className={className}>
      {mapsUrl ? (
        <a
          href={mapsUrl}
          className="exhibition-show-actions__btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          Get directions
        </a>
      ) : null}
      {calendarUrl ? (
        <a
          href={calendarUrl}
          className="exhibition-show-actions__btn"
          target="_blank"
          rel="noopener noreferrer"
        >
          Add to calendar
        </a>
      ) : null}
      {externalUrl ? (
        <a
          href={externalUrl}
          className={`exhibition-show-actions__btn${rsvpOpen ? '' : ' exhibition-show-actions__btn--accent'}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Event page
        </a>
      ) : null}
      {rsvpOpen ? <ExhibitionRsvpButton row={show} compact={compact} /> : null}
    </div>
  );
}
